// 其它
export default [
	{
		path: '/landing',
		name: 'landing',
		component: () => import('@/views/other/landing.js'),
		meta: { title: '加载中...' }
	},
	{
		path: '/agreement/yinsi',
		name: 'AgreementYinsi',
		component: () => import('@/views/agreement/yinsi.vue'),
		meta: { title: '隐私权政策' }
	},
	{
		path: '/agreement/fuwu',
		name: 'AgreementFuwu',
		component: () => import('@/views/agreement/fuwu.vue'),
		meta: { title: '服务协议' }
	},
  {
		path: '/other/qy-explain',
		name: 'AgreementFuwu',
		component: () => import('@/views/other/qy-explain.vue'),
		meta: { title: '迁移说明' }
	}
]
